import React from 'react';
import Search from 'src/assets/images/Search.svg';
import ModalClose from 'src/assets/images/ModalClose.svg';
import {
    SearchBoxContainer,
    StyledInput,
    IconContainer,
    ClearIconContainer,
} from './HighlightSearch.styled';
import { useTranslation } from 'react-i18next';

const HighlightSearch = ({
    searchValue,
    searchHandler,
    clearSearch,
    cursor,
    ShipPlaceholder,
    isEquity,
}) => {
    const { t } = useTranslation();
    return (
        <SearchBoxContainer
            width={'172px'}
            height={'34px'}
            style={{ height: '34px' }}
        >
            <IconContainer
                width={'16px'}
                height={'16px'}
                mobileWidth={'18px'}
                mobileHeight={'18px'}
                opacity={isEquity}
            >
                <img
                    src={Search}
                    alt={'Search Icon'}
                    width={'18px'}
                    height={'18px'}
                />
            </IconContainer>
            <StyledInput
                style={{ backgroundColor: 'transparent' }}
                 id="orders-shipandtrack-highlightsearch-search-input"
                type="text"
                searchImg={Search}
                value={searchValue}
                placeholder={
                    ShipPlaceholder
                        ? t('orders.orderDetails.shipAndTrack.highlightSearch.search')
                        : t('orders.orderDetails.shipAndTrack.highlightSearch.productNumber')
                }
                // placeholder={'Enter Product Number, Keyword or Lot/Serial'}
                onChange={(event) => searchHandler(event)}
                autoComplete="off"
            />
            {searchValue?.length > 0 && (
                <ClearIconContainer id="orders-shipandtrack-highlightsearch-clear-search-button" onClick={clearSearch} cursor={cursor}>
                    <img
                        src={ModalClose}
                        alt={'clearSearch'}
                        width="12px"
                        height="12px"
                    />
                </ClearIconContainer>
            )}
        </SearchBoxContainer>
    );
};

export default HighlightSearch;
